export default __webpack_public_path__ + "static/media/info.3087d089.svg";